export enum PadEnforcementRule {
  Unknown,
  Optional,
  Required,
  NotRequired,
}
